
import { Component, Vue } from "vue-property-decorator";
import AuthHeader from "@/components/layout/auth-header.vue";
import MenuTab from "@/components/layout/menu-tab.vue";

@Component({
  components: {
    AuthHeader,
    MenuTab
  }
})
export default class Preach extends Vue {
  name = "preach";
}
